import { API } from "API/API";

const by_slug = async (slug) => {
  const result = await API.get.wp("webshop/products/get/" + slug, null, {
    next: {
      tags: ["everything", "products", "product_" + slug],
    },
  });

  return result?.data;
};

const preparation_packages = async () => {
  const result = await API.get.wp("webshop/general/preparation_packages", null, {
    next: {
      tags: ["everything", "products", "preparation_packages"],
    },
  });

  return result?.data;
};

const get_slugs = async () => {
  const result = await API.get.wp("webshop/products/get_all?only_slugs=true", null, {
    next: {
      tags: ["everything", "products", "product_slugs", "all_products"],
    },
  });

  return result;
};

const getAll = async () => {
  const result = await API.get.wp("webshop/products/get_all", null, {
    next: {
      tags: ["everything", "products", "all_products"],
    },
  });

  return result?.data?.products || [];
};

export const product = {
  get: {
    slugs: get_slugs,
    by_slug,
    all: getAll,
    preparation_packages,
  },
};
